import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import './CookieBanner.css';
import { analytics } from '../firebase';
import { setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { initPixel } from '../utils/pixel';

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('tapesignal_cookie_consent');
        if (!consent) {
            setIsVisible(true);
        } else if (consent === 'accepted') {
            initPixel();
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('tapesignal_cookie_consent', 'accepted');
        if (analytics) setAnalyticsCollectionEnabled(analytics, true);
        initPixel();
        setIsVisible(false);
    };

    const rejectCookies = () => {
        localStorage.setItem('tapesignal_cookie_consent', 'rejected');
        if (analytics) setAnalyticsCollectionEnabled(analytics, false);
        setIsVisible(false);
    }

    const location = useLocation();
    const allowedPaths = ['/', '/products', '/account', '/duck', '/aurora', '/refract'];
    const shouldShowContactWidget = !isVisible && allowedPaths.includes(location.pathname);

    return (
        <AnimatePresence mode="wait">
            {isVisible && (
                <motion.div
                    key="cookie-banner"
                    className="cookie-banner-overlay"
                    initial={{ y: 150, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 200, opacity: 0 }}
                    transition={{ type: "spring", damping: 20, stiffness: 100 }}
                >
                    <div className="cookie-banner-glass">
                        <div className="cookie-banner-content">
                            <h3>We use cookies 🍪</h3>
                            <p>
                                We use essential cookies to run our store, and optional performance and marketing cookies (like Google Analytics and Facebook Pixel) to improve your experience. See our <Link to="/cookiepolicy">Cookie Policy</Link> for details.
                            </p>
                        </div>
                        <div className="cookie-banner-actions">
                            <button className="cookie-btn-reject" onClick={rejectCookies}>
                                Decline Optional
                            </button>
                            <button className="cookie-btn-accept" onClick={acceptCookies}>
                                Accept All
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}

            {shouldShowContactWidget && (
                <motion.div
                    key="contact-widget"
                    className="cookie-banner-overlay"
                    initial={{ y: 150, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 150, opacity: 0 }}
                    transition={{ type: "spring", damping: 20, stiffness: 100, delay: 0.2 }}
                >
                    <Link to="/contact" className="contact-widget-btn">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C6.48 2 2 5.91 2 10.74C2 13.5 3.33 15.93 5.4 17.48C5.23 18.57 4.54 20.37 4.41 20.73C4.33 20.95 4.5 21.16 4.71 21.09C6.1 20.61 8.35 19.38 9.61 18.49C10.37 18.66 11.17 18.74 12 18.74C17.52 18.74 22 14.83 22 10.74C22 6.65 17.52 2 12 2ZM12 17.26C11.23 17.26 10.47 17.18 9.77 17.02L9.45 16.94L9.16 17.13C8.11 17.82 6.3 18.8 5.17 19.26C5.46 18.41 5.92 16.96 6.09 16.14L6.19 15.65L5.78 15.34C3.96 13.97 2.89 12.06 2.89 10.74C2.89 6.74 6.96 3.48 12 3.48C17.04 3.48 21.11 6.74 21.11 10.74C21.11 14.74 17.04 17.26 12 17.26Z"/>
                            <circle cx="8" cy="11" r="1.5"/>
                            <circle cx="12" cy="11" r="1.5"/>
                            <circle cx="16" cy="11" r="1.5"/>
                        </svg>
                        Contact us
                    </Link>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieBanner;
